import { render, staticRenderFns } from "./PortfolioStockLotFooter.vue?vue&type=template&id=2e34e333&scoped=true&"
import script from "./PortfolioStockLotFooter.vue?vue&type=script&lang=js&"
export * from "./PortfolioStockLotFooter.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioStockLotFooter.vue?vue&type=style&index=0&id=2e34e333&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e34e333",
  null
  
)

export default component.exports